import React from "react"
import GitHubIcon from "@material-ui/icons/GitHub"
import MailOutlineIcon from "@material-ui/icons/MailOutline"
import { IconButton, Box, Typography } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';

import CopyToClipboard from "./CopyToClipboard.tsx"

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.palette.background.paper,
    top: 'auto',
    bottom: 0,
  },
  logo: {
    color: theme.palette.primary.dark,
    fontFamily: 'Poppins',
  },
  grow: {
    flexGrow: 1,
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
  },
}));

const Header = () => {
  

const classes = useStyles();

  return (
    <Box component="header" className={classes.header + " center"}>
      <Box ml={2} pt={2} pb={1}>
          <Typography variant="h5" className={classes.logo}>Plano SP Status</Typography>
      </Box>
      <Box ml={2} pt={1} pb={1}>
        <a
          href="https://github.com/Dereooo/planosp"
          target="_blank"
          rel="noreferrer"
        >
          <IconButton component="span">
            <GitHubIcon fontSize="large" />
          </IconButton>
        </a>
      </Box>
      <Box ml={1} mr={2} pt={1} pb={1}>
        <CopyToClipboard TooltipProps={{ title: "E-mail copiado!", leaveDelay: 3000 }}>
          {({ copy }) => (

        <IconButton 
        onClick={() => copy("josecabadas@gmail.com")}
        component="span">
          <MailOutlineIcon fontSize="large" />
        </IconButton>
          )}
          </CopyToClipboard>
      </Box>
    </Box>
)}

export default Header
